import { pushDataLayer } from 'utils/data-layer-push'
import initCaptcha, { getRecaptchaResponse, recaptachaReset } from 'utils/captcha'
import { t9n } from 't9n/t9n'
declare const CONTACT_URL: string

const validateInput = (input) => {
  if (input.name.length === 0) return 'required-name'

  const nameRegex = new RegExp('^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\\-– ,]*$', 'gim')
  const nameTestResult = !nameRegex.test(input.name)
  if (nameTestResult) return 'invalid-name'

  if (input.mail.length === 0) return 'required-email'

  const mailRegex = new RegExp(
    '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
  )
  const mailTestResult = !mailRegex.test(input.mail.toLowerCase())
  if (mailTestResult) return 'invalid-email'

  const phoneRegex = new RegExp('^([+]?[s0-9]+)?(d{3}|[(]?[0-9]+[)])?([-]?[s]?[0-9])+$')
  if (input.phone.length !== 0) {
    const phoneTestResult = !phoneRegex.test(input.phone)
    if (phoneTestResult) return 'invalid-phone'
  }

  if (input.message.length === 0) return 'required-content'

  return 0
}

const showMessage = (errorIndex: string | number): void => {
  if (errorIndex === 0) return
  let messageData = 'requiredField'
  switch (errorIndex) {
    case 'invalid-phone':
      messageData = 'phoneNotValid'
      break
    case 'invalid-email':
      messageData = 'emailNotValid'
      break
    case 'invalid-name':
      messageData = 'invalidCharacters'
  }

  document.querySelector<HTMLElement>(`[data-error-message='${errorIndex}']`).textContent = t9n(
    `formValidation.${messageData}`,
  )
}

const showErrors = (errorIndex) => {
  if (errorIndex === 0) return
  document.querySelector<HTMLElement>(`[data-error-message='${errorIndex}']`).hidden = false
}

const resetErrors = () => {
  const errorLabels = document.querySelectorAll<HTMLElement>('[data-error-message]')
  errorLabels.forEach((singleElement) => {
    singleElement.hidden = true
  })
}

const mainFunction = () => {
  const formElement = document.querySelector<HTMLFormElement>('#contact-section__from')

  if (formElement) {
    formElement.addEventListener('submit', (e) => {
      e.preventDefault()
      resetErrors()

      const nameInput = formElement.querySelector<HTMLInputElement>("input[name='name']")
      const mailInput = formElement.querySelector<HTMLInputElement>("input[name='email']")
      const phoneInput = formElement.querySelector<HTMLInputElement>("input[name='phone']")
      const messageTextarea = formElement.querySelector<HTMLTextAreaElement>("textarea[name='message']")

      const formInput = {
        name: String(nameInput.value).trim(),
        mail: String(mailInput.value).trim(),
        phone: String(phoneInput.value).trim(),
        message: String(messageTextarea.value).trim(),
      }

      let errorIndex = validateInput(formInput)

      if (errorIndex === 0) {
        errorIndex = getRecaptchaResponse().length === 0 ? 'required-captacha' : 0
      }

      showErrors(errorIndex)
      showMessage(errorIndex)

      if (errorIndex === 0) {
        let messagePayload = `name=${formInput.name}&email=${formInput.mail}&message=${
          formInput.message
        }&captcha=${getRecaptchaResponse()}`

        if (formInput.phone.length) {
          messagePayload += `&phone=${formInput.phone}`
        }

        const xhr = new XMLHttpRequest()
        xhr.open('POST', CONTACT_URL)
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        xhr.onreadystatechange = () => {
          const DONE = 4
          const OK = 201
          if (xhr.readyState === DONE) {
            if (xhr.status === OK || xhr.status === 0) {
              formElement.querySelector<HTMLElement>("[data-cf-alert='success']").hidden = false
              nameInput.value = ''
              mailInput.value = ''
              phoneInput.value = ''
              messageTextarea.value = ''

              pushDataLayer('form_submitted', { form_name: 'Formularz kontaktowy' })
            } else {
              formElement.querySelector<HTMLElement>("[data-cf-alert='fail']").hidden = false
            }

            formElement
              .querySelector<HTMLElement>('[data-cf-alert] .close')
              .addEventListener('click', (e: MouseEvent) => {
                const parentElement = (e.currentTarget as HTMLElement).parentElement
                if (parentElement) parentElement.hidden = true
              })
            recaptachaReset()
          }
        }
        xhr.send(messagePayload)
      }
    })
  }
}

const vcRecaptchaInit = () => {
  initCaptcha()
  mainFunction()
}

export default vcRecaptchaInit
